import { Checkbox as MantineCheckbox, CheckboxProps as MantineCheckboxProps } from "@mantine/core";

export const Checkbox = MantineCheckbox;
export type CheckboxProps = MantineCheckboxProps;
